// @ts-nocheck
import React, { useCallback } from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import CodeIcon from '@mui/icons-material/Code';
import PropTypes from 'prop-types';

import TextField from './TextField';
import { useTableDispatch } from '../../../../context/TableSchemaBuilderContext';

/**
 * FormulaField component for displaying and managing formula-type cell values
 * Consists of a TextField for displaying the formula result with an adjacent formula editor button
 */
const FormulaField = ({
  value,
  onChange,
  format = {},
  inputRef,
  onFocus,
  onBlur,
  cellId,
  disabled,
  ...props
}) => {
  const dispatch = useTableDispatch();

  const handleEditFormula = useCallback(() => {
    dispatch({
      type: 'SET_SHOW_FORMULA_EDITOR',
      payload: true,
    });
    dispatch({
      type: 'SET_CURRENT_CELL',
      payload: cellId,
    });
  }, [dispatch, cellId]);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <Box>
        <TextField
          value={value}
          onChange={onChange}
          inputRef={inputRef}
          format={format}
          onFocus={onFocus}
          onBlur={onBlur}
          disabled={disabled}
          sx={{ flexGrow: 1 }}
          {...props}
          spellCheck={true}
        />
      </Box>

      <Tooltip title={disabled ? 'View Formula' : 'Edit Formula'}>
        <IconButton size="small" onClick={handleEditFormula} sx={{ ml: 0.5 }}>
          <CodeIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

FormulaField.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  format: PropTypes.shape({}).isRequired,
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  onFocus: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  cellId: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default FormulaField;
